import { useQuery } from "@tanstack/react-query";
import { Modal, message } from "antd";
import { useTranslation } from "react-i18next";
import { CiCirclePlus } from "react-icons/ci";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import {
  createStripeAccLink,
  deleteProduct,
  getAllProductsbyBusiness,
} from "../actions/acc_actions";
import ContentLayout from "../components/layout/ContentLayout";
import ShopCard from "../components/ShopCard";
import Loading from "../utils/Loading";

export const redirectToStripeAccountLink = async (accountUrn) => {
  try {
    const res = await createStripeAccLink({ accountUrn });
    const url = res?.data?.accountLink?.url;
    if (url) window.location.href = url;
  } catch (err) {
    console.error("Failed to redirect to Stripe account link:", err);
  }
};

export default function Shop() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const businessSlug = useSelector((state) => state.account.businessSlug);

  const {
    isLoading: productsLoading,
    data: productsData,
    refetch,
  } = useQuery({
    queryKey: ["products", [businessSlug]],
    queryFn: () => getAllProductsbyBusiness(businessSlug),
  });

  if (productsLoading) return <Loading />;

  const products = productsData?.body?.products || [];

  const handleEdit = (productId) => navigate(`${productId}/edit`);

  const handleDelete = (productId) => {
    Modal.confirm({
      title: t("delete_product_confirmation"),
      okText: t("yes_delete"),
      okType: "danger",
      cancelText: t("cancel"),
      onOk: () => {
        deleteProduct(productId)
          .then(() => {
            message.success(t("product_deleted_success"));
            refetch();
          })
          .catch(() => message.error(t("product_delete_failed")));
      },
    });
  };

  return (
    <ContentLayout
      header={
        <>
          <h1>
            {t("market_dashboard_welcome")} <br />{" "}
            <span>{t("market_dashboard")}</span>
          </h1>
        </>
      }
    >
      <div className="outlet-cards">
        <Link to="add" className="outlet-add btn">
          <CiCirclePlus size={48} />
          <div className="outlet-add-content">
            <p>{t("add_new")}</p>
            <h4 className="active">{t("voucher")}</h4>
          </div>
        </Link>

        {products.map((productItem) => (
          <ShopCard
            key={productItem.id}
            product={productItem}
            onEdit={() => handleEdit(productItem.id)}
            onDelete={() => handleDelete(productItem.id)}
          />
        ))}
      </div>
    </ContentLayout>
  );
}
